import React, { useState, useEffect } from 'react'
import Header from '../Header/Header'


import CustomSelect from '../../components/common/CustomSelect'
import CustomHeading from '../../components/common/CustomHeading';
import HRImages from '../../HRComponents/Constant/HRImages';


const ReportPage = () => {
    const [isReport, setIsReport] = useState(false);
    
    // Form state
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    
    // Team and user data
    const [teams, setTeams] = useState([]);
    const [users, setUsers] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);

    useEffect(() => {
       
        const mockTeams = [
            { value: 'team1', label: 'Rough Draft propert' },
            { value: 'team2', label: 'Rough Draft propert' },
            { value: 'team3', label: 'Rough Draft propert' },
        ];
        setTeams(mockTeams);
    }, []);

   
    useEffect(() => {
        if (selectedTeam && !isReport) {
            setIsLoadingUsers(true);
                     const mockUsers = [
                { value: 'user1', label: 'John Doe gjgjjhgjghjghjgjgjhghjghjghjghjghjghjghjghjghjghjghjg' },
                { value: 'user2', label: 'Jane Smith' },
                { value: 'user3', label: 'Mike Johnson' },
            ];
            setTimeout(() => {
                setUsers(mockUsers);
                setIsLoadingUsers(false);
            }, 500);
        } else {
            setUsers([]);
            setSelectedUser(null);
        }
    }, [selectedTeam, isReport]);

    const handleTeamChange = (selectedOption) => {
        setSelectedTeam(selectedOption);
        setSelectedUser(null);
    };

    const handleUserChange = (selectedOption) => {
        setSelectedUser(selectedOption);
    };

    const handleDownload = () => {
        console.log('Download report with:', {
            reportType: isReport ? 'Per Day All User Report' : 'Individual User Report',
            startDate,
            endDate,
            team: selectedTeam,
            user: selectedUser
        });
    };

    const isFormValid = () => {
        if (isReport) {
            return startDate && endDate && selectedTeam;
        } else {
            return startDate && endDate && selectedTeam && selectedUser;
        }
    };

    return (
        <div className="min-h-screen bg-appGrayBackground">
            <Header/>
            <div className="px-6 pt-28 pb-10">
                <div className="flex justify-between items-center mb-8">
                   <CustomHeading title={"Report"} textColor={"primary"} />       
                </div>

                {/* Main Content Grid */}
                <div className="bg-white rounded-[10px] shadow-lg overflow-hidden">
                    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
                        {/* Left Side - Banner Image */}
                        <div className="flex items-center justify-center p-8 lg:p-12">
                            <div className="w-full">
                                <img 
                                    src={HRImages.reportBanner} 
                                    alt="Report Banner"
                                    className="w-full h-auto object-contain"
                                />
                            </div>
                        </div>

                        {/* Right Side - Form */}
                        <div className="p-8 lg:p-12 flex flex-col justify-center">
                            <div className="max-w-lg mx-auto w-full space-y-6">
                                {/* Toggle Switch */}
                                <div className="mb-8">
                                    <div className="relative bg-gray-100 p-1 rounded-xl flex overflow-hidden shadow-inner">
                                        {/* Sliding Background */}
                                        <div
                                            className="absolute top-1 bottom-1 w-[49%] bg-white rounded-lg shadow-md transition-transform duration-300 ease-in-out"
                                            style={{
                                                transform: isReport ? "translateX(100%)" : "translateX(0%)",
                                            }}
                                        />

                                        {/* Individual User Report Option */}
                                        <div
                                            className={`relative z-10 flex-1 text-center cursor-pointer py-3 px-3 text-sm font-medium transition-colors duration-300 ${
                                                !isReport ? "text-customGreen" : "text-gray-600"
                                            }`}
                                            onClick={() => setIsReport(false)}
                                        >
                                            User Performance Report
                                        </div>

                                        {/* Per Day All User Report Option */}
                                        <div
                                            className={`relative z-10 flex-1 text-center cursor-pointer py-3 px-3 text-sm font-medium transition-colors duration-300 ${
                                                isReport ? "text-customGreen" : "text-gray-600"
                                            }`}
                                            onClick={() => setIsReport(true)}
                                        >
                                           Property Report
                                        </div>
                                    </div>
                                </div>

                                {/* Form Fields */}
                                <div className="space-y-6">
                                    {/* Date Range Grid */}
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        {/* Start Date */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Start Date
                                            </label>
                                            <input
                                                type="date"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                                max={new Date().toISOString().split('T')[0]}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-transparent"
                                            />
                                        </div>

                                        {/* End Date */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                End Date
                                            </label>
                                            <input
                                                type="date"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                                min={startDate}
                                                max={new Date().toISOString().split('T')[0]}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-transparent"
                                            />
                                        </div>
                                    </div>

                                    {/* Team and User Selection Grid */}
                                    <div className="grid grid-cols-1 gap-4">
                                    
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Rough Draft propert Selection
                                            </label>
                                            <CustomSelect
                                                options={teams}
                                                value={selectedTeam}
                                                onChange={handleTeamChange}
                                                placeholder="Select Rough Draft propert"
                                                isClearable
                                            />
                                        </div>

                                       
                                    
                                    </div>


                                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Team Selection
                                            </label>
                                            <CustomSelect
                                                options={teams}
                                                value={selectedTeam}
                                                onChange={handleTeamChange}
                                                placeholder="Select Team"
                                                isClearable
                                            />
                                        </div>

                                        {!isReport && (
                                            <div className="transition-all duration-300 ease-in-out">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    User Selection
                                                </label>
                                                <CustomSelect
                                                    options={users}
                                                    value={selectedUser}
                                                    onChange={handleUserChange}
                                                    placeholder={
                                                        isLoadingUsers
                                                            ? "Loading users..."
                                                            : !selectedTeam
                                                            ? "Select a team first"
                                                            : "Select User"
                                                    }
                                                    disabled={!selectedTeam || isLoadingUsers}
                                                    isClearable
                                                />
                                            </div>
                                        )}
                                    </div> */}
                                   

                                    {/* Download Button */}
                                    <div className="pt-4">
                                        <button
                                            onClick={handleDownload}
                                            disabled={!isFormValid()}
                                            className={`w-full py-3 px-6 rounded-lg font-medium text-sm transition-all duration-200 ${
                                                isFormValid()
                                                    ? 'bg-customGreen text-white  shadow-lg  transform hover:-translate-y-0.5'
                                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                            }`}
                                        >
                                            {isLoadingUsers ? 'Loading...' : 'Download Report'}
                                        </button>
                                    </div>
                                </div>

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportPage